export default __webpack_public_path__ + "static/media/FRAME_small.9313f2d1.png";